import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DataTableHelper from "../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import AddUpdModal from "./AddUpdModal";

import {
  getUsers,
  deleteUser,
  resourcesImprevistos,
  activeRoutes,
  resourcesUnits,
  resourcesOperators,
} from "../../helpers/backend_helper";
import { DestroyAlertHelper, Alert } from "../../helpers/alerts/alertHelper";
import { getPolicyUser, getStorageUser } from "../../helpers/api_helper";
import { Container, Row } from "reactstrap";
import { getStorageCompany } from "../../helpers/api_helper";
import ButtonHelper from "../../helpers/ButtonHelper";
import Select from "react-select";
import dayjs from "dayjs";

const Imprevistos = () => {
  let timeElapsed = new Date();
  let dateNow = `${timeElapsed.getFullYear()}-${
    timeElapsed.getMonth() + 1 < 10 ? "0" : ""
  }${timeElapsed.getMonth() + 1}-${timeElapsed.getDate()}`;
  const [date, setDate] = useState({ initDate: "", endDate: "" });
  const policy = getPolicyUser();
  const authUser = getStorageUser();
  const company = getStorageCompany();
  const [pending, setPending] = useState(false);
  const [selects, setSelects] = useState({
    operadores: [],
    operator: null,
    units: [],
    unit: null,
  });
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalObserv, setModalObserv] = useState({
    show: false,
    type: 1,
    id: null,
  });

  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "id",
    order: "asc",
    companySession: company.id,
    dateInit: "",
    dateEnd: "",
    initDate: dateNow,
    endDate: dateNow,
  });
  const [items, setItems] = useState([]);
  const [item, setItem] = useState({});
  const itemBase = {
    fecha: "",
    descripcion: null,
    tipo_id: null,
    castigo_id: null,
    unit_id: null,
    operator_id: null,
    time: "",
  };

  useEffect(() => {
    let params = { params: filters };
    setPending(true);
    resourcesImprevistos("get", params).then((response) => {
      setItems(response.data);
      setDataPag(response.meta);
      setPending(false);
    });
  }, [filters]);

  useEffect(() => {
    const getSelects = async () => {
      let params = { params: { select: true } };
      const units = await resourcesUnits("get", params);
      setSelects({ ...selects, units: units.data });

      const operators = await resourcesOperators("get", params);
      setSelects({ ...selects, operators: operators.data });
    };
    getSelects();
  }, []);

  const addUpd = (row) => {
    console.log(row);
    if (row?.id) {
      setItem(row);
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({
        ...itemBase,
        fecha: dayjs().format("YYYY-MM-DD"),
        time: dayjs().format("HH:mm"),
      });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const destroy = (id) => {
    DestroyAlertHelper(async (confirmed) => {
      if (!confirmed) {
        return;
      }
      resourcesImprevistos("del", id, id).then((response) => {
        Alert(response.message, response.status);
        if (response.status) {
          setItems(items.filter((i) => i.id != id));
        }
      });
    });
  };

  const active = (row) => {
    activeRoutes(row).then((response) => {
      if (response.status) {
        console.log(response.route);
        let newItem = response.route;
        let array = items.map((item) =>
          item.id !== newItem.id ? item : newItem
        );
        setItems(array);
      }
    });
  };
  const columns = Columns(addUpd, destroy, active, setModalObserv);
  document.title = "Imprevistos | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              tittle="Imprevistos"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
            >
              <div className="mb-3">
                <ButtonHelper
                  actionAddButon={() => {
                    addUpd();
                  }}
                  addButon={true}
                />
              </div>

              <div className="col-sm-2">
                <label className="form-label">Unidades:</label>
                <Select
                  className="basic-single"
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={
                    JSON.parse(localStorage.getItem("config"))?.unit
                      ? JSON.parse(localStorage.getItem("config")).unit
                      : selects.unit
                  }
                  isSearchable={false}
                  name="unit"
                  placeholder="Unidades"
                  options={selects.units}
                  getOptionLabel={(option) => `${option.number}`}
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => [
                    setSelects({ ...selects, unit: e }),
                    setFilters({ ...filters, unit_id: e ? e.id : null }),
                  ]}
                />
              </div>
              <div className="col-sm-3">
                <label className="form-label">Fecha Inicial:</label>
                <div className="input-group">
                  <input
                    className="form-control"
                    placeholder="Fecha"
                    name="time"
                    type="date"
                    onChange={(e) =>
                      setFilters({ ...filters, initDate: e.target.value })
                    }
                    value={filters.initDate}
                  />
                </div>
              </div>
              <div className="col-sm-3">
                <label className="form-label">Fecha Final:</label>
                <div className="input-group ">
                  <input
                    className="form-control"
                    placeholder="Fecha"
                    name="time"
                    type="date"
                    onChange={(e) =>
                      setFilters({ ...filters, endDate: e.target.value })
                    }
                    value={filters.endDate}
                  />
                </div>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modal.show && (
          <AddUpdModal
            modal={modal}
            setModal={setModal}
            items={items}
            setItems={setItems}
            item={item}
            setItem={setItem}
            authUser={authUser}
            units={selects.units}
            operators={selects.operators}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default Imprevistos;
